import { atom } from 'jotai';

import { ThumnailType } from '../index.types';

/* 1:1 Thumbnail을 저장하고 렌더링하는 상태값 */
export const thumbnailsAtom = atom<ThumnailType[] | null>(null);
